const ACTIVE_KEY = 'dms_active_logo_id';

export const STATIC_LOGOS = [
  {
    id: 'bir',
    name: 'BIR Logo',
    appName: 'DMS',
    appFullName: 'DMS — Document Management System',
    logoSrc: '/assets/bir.png',
  },
  {
    id: 'endow',
    name: 'ENDOW Logo',
    appName: 'ENDOW',
    appFullName: 'ENDOW — ENDOW',
    logoSrc: '/assets/endow_1.svg',
  },
];

export function getLogos() {
  const activeId = localStorage.getItem(ACTIVE_KEY) || 'bir';
  return STATIC_LOGOS.map((logo) => ({
    ...logo,
    isActive: logo.id === activeId,
  }));
}

export function getActiveLogo() {
  const activeId = localStorage.getItem(ACTIVE_KEY) || 'bir';
  return STATIC_LOGOS.find((l) => l.id === activeId) || STATIC_LOGOS[0];
}

export function setActiveLogo(id) {
  localStorage.setItem(ACTIVE_KEY, id);
  return getLogos();
}

export function loadActiveLogo() {
  if (!localStorage.getItem(ACTIVE_KEY)) {
    localStorage.setItem(ACTIVE_KEY, 'bir');
  }
}
